import { SerializedData, Store } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { PzCampaignSource } from 'sources/pz-campaign-source';
import { action, makeObservable, observable } from 'mobx';
import { PzCampaign } from 'models';

export class PzCampaignStore extends Store {
  public campaign: PzCampaign;
  public campaignTerms: string;
  public campaignTermsId: string;
  public campaignState = 'pending';

  private readonly DEFAULT_LOCALE: string = 'en_us';

  private readonly pzCampaignSource: PzCampaignSource;

  public constructor(pzCampaignSource: PzCampaignSource, state: SerializedData = {}, logger: Logger) {
    super(state, logger);
    this.pzCampaignSource = pzCampaignSource;

    makeObservable(this, {
      campaign: observable,
      campaignTerms: observable,
      campaignTermsId: observable,
      campaignState: observable,
      campaignFetchSuccess: action,
      campaignFetchFailure: action,
    });
  }

  public hydrate(data: SerializedData): void {
    if (data.pzCampaignSource) {
      Object.assign(this.pzCampaignSource, data.pzsource);
    }

    delete data.pzCampaignSource;
    Object.assign(this, data);
  }

  public async fetchCampaign(programName: string, locale: string, defaultLocale: string = this.DEFAULT_LOCALE) {
    this.campaignState = 'pending';

    try {
      const newCampaign = await this.pzCampaignSource.getCampaign(programName);
      this.campaignFetchSuccess(newCampaign, locale.toLowerCase(), defaultLocale);
    } catch (e) {
      this.campaignFetchFailure(e);
    }
  }

  public campaignFetchSuccess = (campaign: PzCampaign, locale: string, defaultLocale: string = this.DEFAULT_LOCALE) => {
    this.campaign = campaign;

    if (campaign.terms) {
      if (campaign.terms[locale]) {
        this.campaignTermsId = campaign.terms[locale].terms_id;
        this.campaignTerms = campaign.terms[locale].terms;
      } else {
        this.campaignTermsId = campaign.terms[defaultLocale].terms_id;
        this.campaignTerms = campaign.terms[defaultLocale].terms;
      }
    }

    this.campaignState = 'done';
  };

  public campaignFetchFailure(error) {
    // tslint:disable-next-line:no-console
    console.log('Campaign terms fetch error ', error);
    this.campaignState = 'error';
  }

  // Old function
  public async getCampaignTerms(programName: string, locale: string, defaultLocale: string = this.DEFAULT_LOCALE) {
    try {
      const response = await this.pzCampaignSource.getCampaign(programName);
      if (response.terms[locale] === undefined) {
        // We expect default locale to be always present
        return response.terms[defaultLocale];
      } else {
        return response.terms[locale];
      }
    } catch {
      return null;
    }
  }
}
